import { LFCONNECT_URLS } from '../GettingStarted/Web/GettingStartedConstants'

export const CALLBACK_URLS = {
    sandbox_oauthEndpoint: 'https://api.developers.lifefitness.com/partnerapi/staging/web/oauthLogin',
    production_oauthEndpoint: 'https://api.developers.lifefitness.com/partnerapi/production/web/oauthLogin',
    sandbox_tokenEndpoint: 'https://api.developers.lifefitness.com/partnerapi/staging/api/v3/oauth/verify-code',
    production_tokenEndpoint: 'https://api.developers.lifefitness.com/partnerapi/production/api/v3/oauth/verify-code',
    sandbox_revokeToken: 'https://api.developers.lifefitness.com/partnerapi/staging/api/v3/oauth/revoke-token',
    production_revokeToken: 'https://api.developers.lifefitness.com/partnerapi/production/api/v3/oauth/revoke-token',
    sandbox_refreshToken: 'https://api.developers.lifefitness.com/partnerapi/staging/api/v3/oauth/refresh-token',
    production_refreshToken: 'https://api.developers.lifefitness.com/partnerapi/production/api/v3/oauth/refresh-token',
}

export const GET_USER_DETAILS_API_CURL_SAMPLE = `GET
curl --location '${LFCONNECT_URLS.sandbox_api}/users' \\
--header 'Accept: application/json' \\
--header 'Authorization: Bearer eyAbc...' \\
--header 'user-access-token: xyz123...'`;

export const GET_ACCESS_TOKEN_API_CURL_SAMPLE = `POST
curl --location '${LFCONNECT_URLS.sandbox_api}/oauth/verify-code' \\
--header 'Authorization: Bearer eyAbc...' \\
--header 'Accept: application/json' \\
--header 'Content-Type: application/json' \\
--data '{
    "code": "b1d67c0d65e61449b94ba33280e43e37|574934"
}'`;

export const GET_ACCESS_TOKEN_SAMPLE_OUTPUT = `{
    "status": "SUCCESSFUL",
    "data": {
        "expiryDate": "2026-04-28T21:47:16.305+00:00",
        "accessToken": "xyz123...",
        "tokenType": "Bearer",
        "refreshToken": "92733cdd75..."
    },
    "error": null,
    "meta": null
}`;

export const REFRESH_TOKEN_SAMPLE_OUTPUT = `{
    "status": "SUCCESSFUL",
    "data": {
        "expiryDate": "2026-04-28T21:47:16.305+00:00",
        "accessToken": "xyz456...",
        "tokenType": "Bearer",
        "refreshToken": "2213d4w73..."
    },
    "error": null,
    "meta": null
}`;

export const REVOKE_TOKEN_USING_ACCESS_TOKEN_POST_REQUEST = `curl --location '${LFCONNECT_URLS.sandbox_api}/oauth/revoke-token' \\
--header 'Authorization: Bearer eyAbc...' \\
--header 'Accept: application/json' \\
--header 'Content-Type: application/json' \\
--data '{
    "accessToken": "cc39a7a858e3bdae5d1b96d63da3fa03|97539511adfa7cb4e60e9c58303e83f9"
}'`;

export const REVOKE_TOKEN_USING_ACCESS_TOKEN_SAMPLE_OUTPUT = `{
    "status": "SUCCESSFUL",
    "data": {
        "accessToken": "cc39a7a858e3bdae5d1b96d63da3fa03|97539511adfa7cb4e60e9c58303e83f9",
        "revokedStatus": true
    },
    "error": null,
    "meta": null
}`;

export const REVOKE_TOKEN_USING_REFRESH_TOKEN_POST_REQUEST = `curl --location '${LFCONNECT_URLS.sandbox_api}/oauth/revoke-token' \\
--header 'Authorization: Bearer eyAbc...' \\
--header 'Accept: application/json' \\
--header 'Content-Type: application/json' \\
--data '{
    "refreshToken": "92733cdd75e7ba5e276479748e996180|9e382d69eae2c1acbb62c6d6c58885ad|921977"
}'`;

export const REVOKE_TOKEN_USING_REFRESH_TOKEN_SAMPLE_OUTPUT = `{
    "status": "SUCCESSFUL",
    "data": {
        "refreshToken": "92733cdd75e7ba5e276479748e996180|9e382d69eae2c1acbb62c6d6c58885ad|921977",
        "revokedStatus": true
    },
    "error": null,
    "meta": null
}`;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Authentication/AuthenticationConstants.js